import { createActions } from 'redux-actions';

export const actions = createActions({
  CLIENT_SEARCH: {
    SET_SEARCH_INDEX: (index) => index,
  },
}).clientSearch;
